export default "__VITE_ASSET__KxJSqyri__"